import React, { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import { db, storage } from "../../utils/firebase";
import { collection, addDoc, deleteDoc, updateDoc, doc, onSnapshot, getDocs, setDoc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import './AdminUsers.css';

const AdminUsers = () => {
    const [users, setUsers] = useState([]);
    const [editingUserId, setEditingUserId] = useState(null); 
    const [updatedUser, setUpdatedUser] = useState({});
    const [selectedImage, setSelectedImage] = useState(null); 
    const [birthday, setBirthday] = useState({ month: '', day: '', year: '' });
    const location = useLocation();
    
  
    useEffect(() => {
    
        const fetchUsers = async () => {
          try {
            const usersCollection = collection(db, "Users");
            const querySnapshot = await getDocs(usersCollection);
            const fetchedUsers = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setUsers(fetchedUsers);
          } catch (error) {
            console.error("Error fetching users: ", error);
          }
        };
    
        fetchUsers();
      }, []);
      

const handleEditClick = (user) => {
    setEditingUserId(user.id);
    setUpdatedUser(user);
    if (user.birthday) {
      const [month, dayYear] = user.birthday.split(" ");
      const [day, year] = dayYear.replace(",", "").split(" ");
      setBirthday({ month, day, year });
    } else {
      setBirthday({ month: "", day: "", year: "" });
    }
  };
  

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUpdatedUser({
          ...updatedUser,
          profile_image: reader.result, 
        });
      };
      reader.readAsDataURL(file);
    }
  };
  
  
  const handleSaveClick = async (userId) => {
    try {
     
      const originalUserDocRef = doc(db, "Users", userId);
      const originalUserSnapshot = await getDoc(originalUserDocRef);
      const originalUserData = originalUserSnapshot.data();
  

      const updatedData = { ...originalUserData, ...updatedUser };
  
    
      updatedData.birthday = birthday.month
        ? `${birthday.month} ${birthday.day}, ${birthday.year}`
        : originalUserData.birthday;
  
  
      if (updatedUser.profile_image && updatedUser.profile_image.startsWith("data:")) {
        const fileName = `profile_images/${userId}/${Date.now()}`;
        const storageRef = ref(storage, fileName);
        const uploadResult = await uploadBytes(storageRef, dataURLtoBlob(updatedUser.profile_image));
        const downloadURL = await getDownloadURL(uploadResult.ref);
        updatedData.profile_image = downloadURL; 
      }
  

      await updateDoc(originalUserDocRef, updatedData);
  

      setEditingUserId(null);
      setUpdatedUser({});
      setSelectedImage(null);
    } catch (error) {
      console.error("Error saving user: ", error);
    }
  };
  

  const handleCancelClick = () => {
    setEditingUserId(null);
    setUpdatedUser({});
    setSelectedImage(null);
  };
  
  
  const handleChange = (e) => {
    setUpdatedUser({
      ...updatedUser,
      [e.target.name]: e.target.value,
    });
  };
  
 
  const handleBirthdayChange = (e, field) => {
    setBirthday((prevBirthday) => ({
        ...prevBirthday,
        [field]: e.target.value,
    }));
};
  

  const dataURLtoBlob = (dataURL) => {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  
      
      

      const handleDeleteClick = async (userId) => {
        try {
          const userRef = doc(db, "Users", userId);
          const userSnapshot = await getDoc(userRef);
          const userData = userSnapshot.data();
    
      
          await setDoc(doc(db, "user_archives", userId), userData);
    
      
          await deleteDoc(userRef);
    
 
          setUsers(users.filter(user => user.id !== userId));
        } catch (error) {
          console.error("Error deleting user: ", error);
        }
      };

      
    
      return (
        <div className="admin-page">
          <Navbar />
          <div className="admin-container">
          <div className="admin-sidebar">
          <h2>Admin Panel</h2>
          <Link to="/adminusers" className={`sidebar-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>Users</Link>
          <Link to="/adminposts" className={`sidebar-button ${location.pathname === '/adminposts' ? 'active' : ''}`}>User Posts</Link>
          <Link to="/adminfeedback" className={`sidebar-button ${location.pathname === '/adminfeedback' ? 'active' : ''}`}>User Feedback</Link>
          <Link to="/announcementadmin" className={`sidebar-button ${location.pathname === '/announcementadmin' ? 'active' : ''}`}>Announcements</Link>
          <Link to="/exploreaboutadmin" className={`sidebar-button ${location.pathname === '/exploreaboutadmin' ? 'active' : ''}`}>Explore about Bacoor</Link>

          <h2>Places to Visit</h2>
          <Link to="/bridgesadmin" className={`sidebar-button ${location.pathname === '/bridgesadmin' ? 'active' : ''}`}>Bridges & Dams</Link>
          <Link to="/monumentsadmin" className={`sidebar-button ${location.pathname === '/monumentsadmin' ? 'active' : ''}`}>Monuments & Statues</Link>
          <Link to="/houseadmin" className={`sidebar-button ${location.pathname === '/houseadmin' ? 'active' : ''}`}>Ancestral Houses</Link>
          <Link to="/churchesadmin" className={`sidebar-button ${location.pathname === '/churchesadmin' ? 'active' : ''}`}>Churches & Religious Sites</Link>

          <h2>Things to Do</h2>
          <Link to="/recreationaladmin" className={`sidebar-button ${location.pathname === '/recreationaladmin' ? 'active' : ''}`}>Recreational Activities</Link>
          <Link to="/diningadmin" className={`sidebar-button ${location.pathname === '/diningadmin' ? 'active' : ''}`}>Dining and Culinary</Link>
          <Link to="/shoppingadmin" className={`sidebar-button ${location.pathname === '/shoppingadmin' ? 'active' : ''}`}>Shopping and Market</Link>

          <h2>Archives</h2>
          <Link to="/userarchive" className={`sidebar-button ${location.pathname === '/userarchive' ? 'active' : ''}`}>Users</Link>
          <Link to="/postsarchive" className={`sidebar-button ${location.pathname === '/postsarchive' ? 'active' : ''}`}>Posts</Link>
          <Link to="/feedbackarchive" className={`sidebar-button ${location.pathname === '/feedbackarchive' ? 'active' : ''}`}>Feedback</Link>
          <Link to="/announcementarchive" className={`sidebar-button ${location.pathname === '/announcementarchive' ? 'active' : ''}`}>Announcements</Link>
        </div>
        
            <div className="admin-content">
              <div className="table-container">
                <h2>User Management</h2>
                {users.length > 0 ? (
                  <table>
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Gender</th>
                        <th>Birthday</th>
                        <th>Email</th>
                        <th>Photo</th>
                        <th>Password</th>
                        <th>Role</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user) => (
                        <tr key={user.id}>
                          <td>
                            {editingUserId === user.id ? (
                              <input
                                type="text"
                                name="firstName"
                                value={updatedUser.firstName}
                                onChange={handleChange}
                              />
                            ) : (
                              user.firstName
                            )}
                          </td>
                          <td>
                            {editingUserId === user.id ? (
                              <input
                                type="text"
                                name="lastName"
                                value={updatedUser.lastName}
                                onChange={handleChange}
                              />
                            ) : (
                              user.lastName
                            )}
                          </td>
                          <td>
                          {editingUserId === user.id ? (
                    <select
                    name="gender"
                    value={updatedUser.gender}
                    onChange={handleChange}
                    >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="PreferNotToSay">Prefer not to say</option>
                    </select>
                ) : (
                    user.gender
                )}
                          </td>
                          <td>
                          {editingUserId === user.id ? (
                    <>
                        <div>
                            <select
                                name="month"
                                value={birthday.month || ''}
                                onChange={(e) => handleBirthdayChange(e, 'month')}
                            >
                                {[
                                    "January", "February", "March", "April", "May", "June",
                                    "July", "August", "September", "October", "November", "December"
                                ].map((month) => (
                                    <option key={month} value={month}>
                                        {month}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <select
                                name="day"
                                value={birthday.day || ''}
                                onChange={(e) => handleBirthdayChange(e, 'day')}
                            >
                                {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                    <option key={day} value={day}>
                                        {day}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <select
                                name="year"
                                value={birthday.year || ''}
                                onChange={(e) => handleBirthdayChange(e, 'year')}
                            >
                                {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(
                                    (year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    )
                                )}
                            </select>
                        </div>
                    </>
                ) : (
                    user.birthday || "Not specified"
                )}        
                          </td>
                          <td>
                            {editingUserId === user.id ? (
                              <input
                                type="email"
                                name="email"
                                value={updatedUser.email}
                                onChange={handleChange}
                              />
                            ) : (
                              user.email
                            )}
                          </td>
                          <td>
                            {editingUserId === user.id ? (
                              <>
                                <input type="file" onChange={handleImageChange} />
                                {selectedImage && (
                                  <img
                                    src={URL.createObjectURL(selectedImage)}
                                    alt="Preview"
                                    width="60"
                                    height="60"
                                  />
                                )}
                              </>
                            ) : (
                              <img src={user.profile_image} alt="Profile" width="60" />
                            )}
                          </td>
                          <td>
                            {editingUserId === user.id ? (
                              <input
                                type="password"
                                name="password"
                                value={updatedUser.password}
                                onChange={handleChange}
                              />
                            ) : (
                              '*****'
                            )}
                          </td>
                          <td>{editingUserId === user.id ? (
                                <select
                                name="role"
                                value={updatedUser.role}
                                onChange={(e) => handleChange(e, user.id)}
                                >
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                                </select>
                            ) : user.role}</td>
                      <td>
                        {editingUserId === user.id ? (
                          <>
                            <button
                              className="save-btn btn btn-success"
                              onClick={() => handleSaveClick(user.id)}
                            >
                              <i className="bi bi-check"></i>
                            </button>
                            <button
                              className="cancel-btn btn btn-secondary"
                              onClick={handleCancelClick}
                            >
                              <i className="bi bi-x"></i>
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="edit-btn btn btn-primary"
                              onClick={() => handleEditClick(user)}
                            >
                              <i className="bi bi-pencil"></i>
                            </button>
                            <button
                              className="delete-btn btn btn-danger"
                              onClick={() => handleDeleteClick(user.id)}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </>
                        )}
                      </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No users found</p>
                )}
              </div>
            </div>
          </div>
          <Footer />
        </div>
      );
    };
  
  export default AdminUsers;